import { Checkbox, Flex, Spacing, Text } from '@billy/design-system'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { ReportsDisplayOption, useSalesReportFilters } from '../../../../../../hooks/useSalesReportFilters'
import * as Styled from './styles'

export const SalesReportDisplayOptions = () => {
  const { t } = useTranslation()

  const [{ shouldShowVat: queryParamShouldShowVat }, setQueryParams] = useSalesReportFilters()

  const handleCheckboxClick = (option: ReportsDisplayOption, event: ChangeEvent<HTMLInputElement>) => {
    setQueryParams({ [option]: event.currentTarget.checked })
  }

  return (
    <Styled.SalesReportDisplayOptionsWrapper>
      <Flex flexDirection="column" gap={Spacing.S12}>
        <Text variant="bodySM" colorVariant="secondary" uppercase>
          {t('sales_report.sales_overview.display_options.title')}
        </Text>
        <Checkbox
          value="shouldShowVat"
          checked={queryParamShouldShowVat}
          onChange={(event) => handleCheckboxClick('shouldShowVat', event)}
        >
          {t('sales_report.sales_overview.display_options.show_vat')}
        </Checkbox>
      </Flex>
    </Styled.SalesReportDisplayOptionsWrapper>
  )
}
